exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.paymentRowsHolder[data-v-403dcc8d] {\n  max-height: 200px;\n  overflow: auto;\n}\n.paymentRowsHolder div[data-v-403dcc8d]:nth-child(odd) {\n    background-color: #f5f8fa;\n}\n.payMethod[data-v-403dcc8d] {\n  width: 103px;\n  height: 72px;\n}\n.payMethod.selected[data-v-403dcc8d] {\n    border-color: #222c3c !important;\n    border-width: 2px !important;\n}\n.payMethod[data-v-403dcc8d]:hover {\n    background-color: #f5f8fa;\n}\n.popupBg[data-v-403dcc8d] {\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  position: absolute;\n}\n.popupBg .popupArea[data-v-403dcc8d] {\n    width: 800px;\n    max-height: 100%;\n    margin: 0 auto;\n    overflow: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-403dcc8d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEdit/EditTransport.vue
// module id = 1700
// module chunks = 0